import { db } from './db';

export async function queueAction(url, method, body) {
  await db.pendingSync.add({
    url,
    method,
    body: JSON.stringify(body),
    createdAt: new Date().toISOString(),
  });
}

export async function processSyncQueue() {
  const actions = await db.pendingSync.toArray();
  for (const action of actions) {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(action.url, {
        method: action.method,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: action.body,
      });
      if (response.ok) {
        await db.pendingSync.delete(action.id);
        // Opcional: atualizar dados locais com a resposta, se necessário
      } else {
        console.warn('Falha ao sincronizar ação', action, response.status);
        // Mantém na fila para tentar depois
      }
    } catch (err) {
      console.error('Erro ao sincronizar ação', action, err);
    }
  }
}